// API Configuration for Banverse
// When deploying to a Virtual Machine, change these to the VM's public IP or Domain name
const API_BASE_URL = "http://localhost:5001";
const AI_BASE_URL = "http://localhost:8000";

const config = {
    API_BASE_URL,
    AI_BASE_URL
};

export default config;
